import QrCodeReader from './QrCodeReader';

export * from './types';

export default QrCodeReader;
